import { VueModule } from '@Foundation/utilities';
import Whatsapp from './code/Scripts/components/whatsapp';

export default VueModule({
  components: {
    Whatsapp
  }
});